webpackJsonp([239733815803947],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _serviciiManagementProiectLarge = __webpack_require__(473);
	
	var _serviciiManagementProiectLarge2 = _interopRequireDefault(_serviciiManagementProiectLarge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    var pageSEO = {
	      title: "Servicii de management de proiect",
	      description: "va oferim servicii de management de proiect pentru imobilul dvs.",
	      path: "/servicii/management-proiect/"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: "o-page__content" },
	      _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	      _react2.default.createElement(
	        "div",
	        { className: "c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-pv-20 u-pv-30@tablet u-text-center@tablet" },
	          _react2.default.createElement(
	            "h1",
	            { className: "c-page__heading" },
	            "Servicii de management de proiect"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "o-container u-pv-20 u-pv-30@tablet u-bg-white" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container o-container--text u-ph-0" },
	          _react2.default.createElement("img", { className: "u-mb-20", src: _serviciiManagementProiectLarge2.default, alt: "servicii management de proiect" }),
	          _react2.default.createElement(
	            "ol",
	            { className: "o-list-10-v" },
	            _react2.default.createElement(
	              "li",
	              null,
	              "Mentinerea leg\u0103turii cu proprietarii de apartamente, sau dupa caz cu pre\u0219edintele \u0219i comitetul asocia\u021Biei de proprietari."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Negocierea contractelor cu furnizorii \xEEn interesul proprietarilor si colaborarea cu acestia pe parcursul derularii contractului."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "In cazul existentei poli\u021Belor de asigurare pe cladire, se va asigura gestionarea acestora.\u2028"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Organizarea, supravegherea si controlul lucrarilor de intretinere si imbunatatire a propriet\u0103\u021Bii, conform deciziilor proprietarilor.\u2028"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Consultan\u021B\u0103 privind activitatea de administrare a imobilului."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Perfectarea si verificarea documentatiei in vederea semnarii contractelor cu furnizorii de servicii."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Supravegherea derularii optime a contractelor incheiate intre proprietari si furnizorii de servicii."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Informarea proprietarilor cu privire la actualizarile legilor \u0219i reglement\u0103rilor legale precum \u0219i a hot\u0103r\xE2rilor emise de Prim\u0103ria sectorului \u0219i de Prim\u0103ria Municipiului Bucure\u0219ti."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Respectarea altor obliga\u021Bii stabilite prin contract, in conditiile legii.\u2028"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Propunerea bugetului pentru anul urmator in functie de cheltuielile curente pentru anul respectiv si proiectele ce urmeaza a fi dezvoltate."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Alte sarcini hot\u0103r\xE2te prin contractul de administrare."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "u-text-center" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/preturi/", className: "c-button u-mt-30" },
	              "Solicita o oferta personalizata"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/servicii-management-proiect-large.faecd8ce.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-servicii-management-proiect-js-4949ee21257abff7dad5.js